import { useState } from "react";
import { Button, Checkbox, Header, Form } from "semantic-ui-react";

const GetPaidNow = (props) => {
  const { handleUpdateJob } = props;
  const [isChecked, setChecked] = useState(false);
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Form size="large">
        <Header>
          Get Paid Now
          <Header.Subheader>
            Stenexus is proud to offer "Get Paid Now" to Court Reporters booking
            jobs through the Stenexus platform. By default, Stenexus pays you,
            the Court Reporter, once the invoice is paid by the requesting
            Attorney/Law Firm. Stenexus terms allow up to 90 days for invoices
            to be paid. Instead of waiting, for a small fee you can get paid
            today by Stenexus.
          </Header.Subheader>
        </Header>
        <Form.Field>
          <Checkbox
            checked={isChecked}
            onChange={() => setChecked(!isChecked)}
            label="I agree to a 5% fee deducted from the total invoice for this job, and to receive payment to my preconfigured Stripe account."
          />
        </Form.Field>
        <Form.Field>
          <Button
            disabled={!isChecked}
            fluid
            content="Agree and Get Paid"
            size="large"
            positive
            onClick={() => handleUpdateJob(null, true)}
          />
        </Form.Field>
      </Form>
    </div>
  );
};
export default GetPaidNow;
